import axios from "axios";
import { API_BASE } from "../config/constants";

export const eventScheduleResource = axios.create({
  baseURL: `${API_BASE}/api/v1/event-schedule`,
  headers: {
    "Content-Type": "application/json",
    Authorization: "ApiKey 525c17aa-4a83-4777-bba0-a6e463388b32",
  },
});

export const pageTypeResource = axios.create({
  baseURL: `${API_BASE}/api/v1/pageType`,
  headers: {
    "Content-Type": "application/json",
  },
});

export const eventScheduleGroupResource = axios.create({
  baseURL: `${API_BASE}/api/v1/event-schedule-group`,
  headers: {
    "Content-Type": "application/json",
    Authorization: "ApiKey 525c17aa-4a83-4777-bba0-a6e463388b32",
  },
});
